<template>
  <v-card @click="openCheckout(eventData)" class="event-item">
    <a>
      <v-card  flat>
        <v-img :aspect-ratio="1.73" style="width: 390px !imporant" class="img-card lazy" :src="img" >
        </v-img>
        <v-card-text class="favorite-card">
          <v-btn @click.prevent="() => {}" absolute fab top right  v-show="showFav">
            <v-icon>favorite_border</v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text class="event-status-card" v-show="isCancelled()">
          <v-chip disabled text-color="white">
            <v-avatar>
              <v-icon outline>info</v-icon>
            </v-avatar>
            Cancelado
          </v-chip>
        </v-card-text>

        <v-card-title primary-title class="information" style="margin-top: -18px">
          <div class="box-card">
            <div><span class="title" style="color: black">{{ title }}</span></div>
            <!-- <div class="description date-blue">{{ description_1 }} <span v-show="!!description_2 && description_2.length > 0">•</span> {{ description_2 }}</div> -->
            <div class="description date-blue"><span style="color: black">{{ description_1 }}</span></div>
            <div style="color: black">{{ description_3 }} <span style="color: black" v-if="eventData && eventData.tipo_local !== 'online'">•</span> {{ eventData && eventData.tipo_local !== 'online' ? description_4 : ''}} {{eventData.tipo_local === 'hibrido' ? '+ Online' : ''}}</div>
          </div>
        </v-card-title>
      </v-card>
    </a>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'EventItem',
  props: {
    eventData: {
      type: Object,
      default: null
    },
    link: {
      type: [String, Object],
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description_1: {
      type: String,
      default: ''
    },
    description_2: {
      type: String,
      default: ''
    },
    description_3: {
      type: String,
      default: ''
    },
    description_4: {
      type: String,
      default: ''
    },
    showFav: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      image: 'https://via.placeholder.com/250/?text= ',
      enableCall: false,
      loadingButtons: true
    }
  },
  computed: {
    ...mapGetters({
      loadingButtonNatal: 'events/loadingButtonNatal'
    })
  },
  methods: {
    ...mapActions({
      addVisited: 'search/addVisited',
      setLoading: 'setLoading'
    }),
    isCancelled () {
      return (!!this.eventData.data_cancelamento && (this.eventData.data_cancelamento != 0))
    },
    closeDialog () {
      this.dialog = false
    },
    async openCheckout (eventData) {
      // await this.$store.dispatch('loadCheckoutState', eventData.codigo);
      this.$router.push(`/${eventData.codigo}/totem`)
      // window.open(`/27765/totem`)
    }
  },
  watch: {
    img (value) {
      if (!/placeholder/gi.test(this.image)) {
        this.image = value
      }
    }
  }
}
</script>

<style scoped>
.show-event-bt {
  text-transform: none !important;
  line-height: 24px;
  font-size: 14px;
  letter-spacing: 0.1px;
  text-align: center;
  color: #770700;
  border-radius: 20px;
  width: 160px;
  box-shadow: none !important;
}
.bt-buttons{
  text-transform: none !important;
  line-height: 24px;
  font-size: 14px;
  letter-spacing: 0.1px;
  text-align: center;
  color: #ffffff;
  background: #770700 !important;
  border-radius: 20px;
  width: 160px;
  box-shadow: none !important;
}
</style>
